// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"2e14c8362dc553e9","node_modules_dompurify_dist_purify_es_mjs":"5d1c3eab1e429a6d","node_modules_canvg_lib_index_es_js":"318bb691b0b3a05a"}[chunkId] + ".js";
};